import { combineReducers } from 'redux';
import { GET_ENROLLMENT, GET_SECTIONS, ADD_SECTIONS, getEnrollment, DELETE_ENROLLMENT, GET_COURSE_USERS, COMBINED_USERS } from '../actions/courses';
import { getSectionEnrollment } from '../actions/sections';
import { createActionReducer, createFlagReducer } from '../utils/genericReducer';
import { createActionMiddleware } from '../utils/genericMiddleware';

export const coursesReducer = combineReducers({
	allEnrollments: createActionReducer(GET_ENROLLMENT),
	sections: createActionReducer(GET_SECTIONS),
	allUsers: createFlagReducer(COMBINED_USERS),
    sectionCreated: createActionReducer(ADD_SECTIONS),
    users: createActionReducer(GET_COURSE_USERS),
});

const getEnrollmentUrl = (action) => {
    let courseEnrollment = `/api/v1/courses/${action.courseId}/enrollments?include%5B%5D=can_be_removed`;
    return {
        url: courseEnrollment,
        method: 'GET',
        token: action.token
    }
}

const deleteEnrollmentUrl = (action) => {
    return {
        url: `/api/v1/courses/${action.courseId}/enrollments/${action.id}?task=delete`,
        method: 'DELETE',
        token: action.token
    }
}

const getSectionsUrl = (action) => {

    let courseSections = `/api/v1/courses/${action.courseId}/sections?include%5B%5D=total_students`;
    return {
        url: courseSections,
        method: 'GET',
        id: action.courseId,
        token: action.token
    }
}

const addSectionsUrl = (action) => {

    return {
        url: `/api/v1/courses/${action.id}/sections`,
        method: 'POST',
        body: action.data,
        token: action.token
    }
}

const getCourseUsersUrl = (action) => {

    let courseUserUrl = `/api/v1/courses/${action.id}/search_users?include%5B%5D=enrollments&&per_page=15`;
    if(action.newUrl) {
        courseUserUrl = action.newUrl
    }

    if(action.searchFilter) {
        courseUserUrl += `&search_term=${action.searchFilter}`
    }

    return {
        url: courseUserUrl,
        noLoop: true,
        method: 'GET',
        token: action.token
    }
}

const afterDeleteResult = (store, action, res) => {
    const sectionId = res && res.data && res.data[0] && res.data[0].course_section_id;
    const token = action.token;
    const id = action.courseId;
    store.dispatch(getSectionEnrollment(sectionId, token))
    store.dispatch(getEnrollment(id, token))
}

// set up for middleware operations
// helpful for making async and api calls
export const coursesMiddleware = [
    createActionMiddleware(GET_ENROLLMENT, getEnrollmentUrl),
    createActionMiddleware(GET_SECTIONS, getSectionsUrl),
    createActionMiddleware(GET_COURSE_USERS, getCourseUsersUrl),
    createActionMiddleware(DELETE_ENROLLMENT, deleteEnrollmentUrl, afterDeleteResult),
    createActionMiddleware(ADD_SECTIONS, addSectionsUrl)
];